import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AccountsService, IApplyReset } from 'app/system/services/accounts.service';
import { IApiError, ApiErrorType } from 'app/system/services/api.service';

@Injectable()
export class LoginActivateResolve implements Resolve<IApiError> {

  constructor(
    private accountsService: AccountsService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IApiError> {

    const activation = <IApplyReset>{
      email: route.queryParams['email'],
      refresh_token: route.queryParams['token']
    };

    return this.accountsService.activate(activation).pipe(
      map(() => {
        return <IApiError>{
          message: 'User sucessfully activated!',
          type: ApiErrorType.Info
        };
      }),
      catchError(error => {
        return of(this.accountsService.service.getApiErrorFromCatch(error));
      })
    );
  }
}
